export const STOCK: ReadonlyArray<{
  id: number;
  name: string;
  stock: ReadonlyArray<string>;
}> = [
  {
    id: window.location.hostname.endsWith('claire.nowomed.com') ? 7 : 197,
    name: 'MYCANNABIS (360Grad-Apotheke)',
    stock: [
      'Barongo 24/1 Upside Down Cake',
      'Barongo 26/1 Kali',
      'Barongo 24/1 Banjo',
      'Barongo 26/1 SSS (Sunset Strudel)',
      'Barongo 27/1 MAC3',
      'Barongo 28/1 SR (Skiltz Runtz)',
      'Buuo 24/1 JGB (Juggernaut Gas Breath)',
      'Buuo 22/1 CDLC (Cold Dank Jelly Breath)',
      'enua 22/1 SAM CA (Super Alien Mints)',
      'enua 22/1 BCP CA (Black Cherry Punch)',
      'enua 25/1 SC CA (Strawberry Cake)',
      'Haua 25/1 CA ALM (Alien Mints)',
      'Aurora 22/1 (Delahaze)',
      'Remexian 27/1 CIV PKU (Poison Kush)',
    ],
  },
];
